// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prd.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  env: 'dev',
  mock: false,
  apiUrl: 'https://api-all-in-one2.clddev.bonduelle.com/',
  loginUrl: 'https://ssoconnect.clddev.bnd-services.com/login?client_id=7qjor0jelgoi4cvdqveraml3b&response_type=code&scope=aws.cognito.signin.user.admin+email+openid&redirect_uri=https://api-all-in-one2.clddev.bonduelle.com/auth/callback'
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
